import React from 'react';
import { CardHeader, Tooltip } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-pro';

import { DataGrid, PageTitleWithToolTip } from '../Common';
import { StyledCellLink } from '../Common/DataGrid/CellComponents';
import { text_commonCellProps } from '../Common/DataGrid/utils';
import { getDateRangeFilterOperator } from '../Common/DataGrid/FilterComponents';

import { Grey2 } from '../../color_utils';
import { useNavigate } from '../../hooks';
import Routes from '../../routes';

const dateRangeFilterOperator = getDateRangeFilterOperator({});

const columns = [
    {
        field: 'name',
        headerName: 'Asset name',
        ...text_commonCellProps,
        renderCell: ({ row: { name, id } }) => (
            <StyledCellLink
                path={`/Inventory/${id}`}
                text={name}
                from={window.location.pathname}
            />
        )
    },
    {
        field: 'firstBillDate',
        headerName: 'First bill date',
        filterOperators: dateRangeFilterOperator

    },
    {
        field: 'inactiveDate',
        headerName: 'Inactive date',
        filterOperators: dateRangeFilterOperator

    },
    {
        field: 'inUse',
        headerName: 'In use',
        ...text_commonCellProps
    },
    {
        field: 'metered',
        headerName: 'Metered',
        ...text_commonCellProps
    },
    {
        field: 'meterType',
        headerName: 'Meter type',
        ...text_commonCellProps
    },
    {
        field: 'usageUnits',
        headerName: 'Usage units',
        ...text_commonCellProps
    },
    {
        field: 'demandUnits',
        headerName: 'Demand units',
        ...text_commonCellProps
    },
]

const InventoryMeter = ({
    id,
}) => {

    const navigate = useNavigate({
        pageName: "inventoryMeter"
    });

    const actionRow = {
        type: 'actions',
        field: 'Quick Actions',
        width: 100,
        getActions: ({ row }) => {

            const { id } = row;
            const quickActions = [
                <GridActionsCellItem
                    icon={
                        <Tooltip
                            title="View Asset"
                        >
                            <SearchIcon sx={{ color: Grey2 }} />
                        </Tooltip>
                    }
                    onClick={() => navigate.push(`/Inventory/${id}`)}
                />,
                <GridActionsCellItem
                    icon={
                        <Tooltip
                            title="View History"
                        >
                            <HistorySearchIcon sx={{ color: Grey2 }} />
                        </Tooltip>
                    }
                    onClick={() => navigate.push(`/Inventory/${id}#History`)}
                />
            ];

            return quickActions;
        }
    }

    return (
        <>
            <DataGrid
                url={Routes.Location.InventoryTable(id, false, false, true, false)}
                noResultText="Oops...It is empty here..."
                noResultText2="Create a new Meter or change your search criteria."
                columns={[...columns, actionRow]}
                headerContent={
                    <CardHeader
                        title={
                            <PageTitleWithToolTip
                                pageTitle={"Meters"}
                            />
                        }
                        sx={{
                            "& .MuiCardHeader-action": { display: "flex" },
                            "& .MuiCardHeader-content": { maxWidth: "100%", textWrap: "nowrap" }
                        }}
                    />
                }
                hideExportButton={true}
            />
        </>
    )
}
export default InventoryMeter;
